/**
 * @license
 * Copyright 厦门乾元盛世科技有限公司 All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file.
 */


import { Component, Input, Output, EventEmitter, ElementRef, Renderer, HostBinding, HostListener, ViewEncapsulation } from '@angular/core';
import classNames from 'classnames';
export class CheckableTag {
/**
 * 样式前缀
 */
prefixCls = 'ant-tag';
/**
 * 标签是否可以关闭
 */
closable = false;
/**
 * 设置标签的选中状态
 */
checked = false;
/**
 * 用户CSS样式
 */
class: string;
/**
 * 点击标签时触发的事件
 */
change = new EventEmitter<boolean>();
/**
 * @param {?} renderer
 * @param {?} elementRef
 */
constructor(private renderer: Renderer,
private elementRef: ElementRef) {

    }
/**
 * @return {?}
 */
get classes(): string {
        const /** @type {?} */ classString = classNames(this.prefixCls, {
            [`${this.prefixCls}-checkable`]: true,
            [`${this.prefixCls}-checkable-checked`]: this.checked
        }, this.class);

        return classString;
    }
/**
 * @param {?} event
 * @return {?}
 */
handleClick(event: Event): void {
        this.change.emit(!this.checked);
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ant-checkable-tag',
    template: `<ng-content></ng-content>`,
    styleUrls: ['./style/index.scss'],
    encapsulation: ViewEncapsulation.None
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer, },
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'prefixCls': [{ type: Input },],
'closable': [{ type: Input },],
'checked': [{ type: Input },],
'class': [{ type: Input },],
'change': [{ type: Output },],
'classes': [{ type: HostBinding, args: ['class', ] },],
'handleClick': [{ type: HostListener, args: ['click', ['$event'], ] },],
};
}

function CheckableTag_tsickle_Closure_declarations() {
/** @type {?} */
CheckableTag.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CheckableTag.ctorParameters;
/** @type {?} */
CheckableTag.propDecorators;
/**
 * 样式前缀
 * @type {?}
 */
CheckableTag.prototype.prefixCls;
/**
 * 标签是否可以关闭
 * @type {?}
 */
CheckableTag.prototype.closable;
/**
 * 设置标签的选中状态
 * @type {?}
 */
CheckableTag.prototype.checked;
/**
 * 用户CSS样式
 * @type {?}
 */
CheckableTag.prototype.class;
/**
 * 点击标签时触发的事件
 * @type {?}
 */
CheckableTag.prototype.change;
/** @type {?} */
CheckableTag.prototype.renderer;
/** @type {?} */
CheckableTag.prototype.elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
